import React from "react";
import TablePreviewWrapper from "./preview/TablePreview";

interface MessageProps {
    message: {
        role: "system" | "user" | "assistant";
        extra?: {
            userFacingMessage?: string;
            backgroundMessage?: string;
            data?: {
                data?: any;
                function?: string;
            };
        };
    };
    isLoading?: boolean;
}

const MessageComponent: React.FC<MessageProps> = ({
    message,
    isLoading = false,
    setTableData,
}) => {
    return (
        <div style={{ marginBottom: "10px" }}>
            <div>
                <strong>
                    {message.role === "user" ? "You" : "Assistant"}:
                </strong>{" "}
                {isLoading && message.role === "assistant" ? (
                    <div
                        style={{
                            display: "inline-block",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    background: "#007bff",
                                    margin: "0 2px",
                                    animation: "pulse 1s infinite",
                                }}
                            ></span>
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    background: "#007bff",
                                    margin: "0 2px",
                                    animation: "pulse 1s infinite 0.2s",
                                }}
                            ></span>
                            <span
                                style={{
                                    display: "inline-block",
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    background: "#007bff",
                                    margin: "0 2px",
                                    animation: "pulse 1s infinite 0.4s",
                                }}
                            ></span>
                            <style>{`
              @keyframes pulse {
                0% { opacity: 0.4; transform: scale(1); }
                50% { opacity: 1; transform: scale(1.2); }
                100% { opacity: 0.4; transform: scale(1); }
              }
            `}</style>
                        </div>
                        <div
                            style={{
                                display: "inline-block",
                                paddingLeft: "10px",
                            }}
                        >
                            {message.extra?.userFacingMessage}
                        </div>
                    </div>
                ) : (
                    message?.extra?.userFacingMessage
                )}
            </div>

            {/* Option to view background details */}
            {!isLoading &&
                (message?.extra?.backgroundMessage ||
                    message?.extra?.data?.data ||
                    message?.extra?.data?.function) && (
                    <details>
                        <summary>Show Background Info</summary>
                        <div>{message?.extra?.backgroundMessage}</div>
                        <br />
                        {message.extra?.data?.data && (
                            <div
                                style={{
                                    padding: "20px",
                                    background: "#ccc",
                                }}
                            >
                                {JSON.stringify(
                                    message.extra?.data?.data ?? {},
                                )}
                            </div>
                        )}
                        <br />
                        {message.extra?.data?.function && (
                            <div
                                style={{
                                    padding: "20px",
                                    background: "gray",
                                }}
                            >
                                {message.extra?.data?.function}
                            </div>
                        )}
                    </details>
                )}

            {message.role === "assistant" && !isLoading && (
                <div
                    style={{
                        width: "100%",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "2px 4px 5px inset black",
                        position: "relative",
                    }}
                >
                    <TablePreviewWrapper
                        dataObject={message.extra?.data}
                        setTableData={setTableData}
                    />
                </div>
            )}
        </div>
    );
};

export default MessageComponent;
